import React from 'react'
import _ from 'lodash'

import { FormContext } from 'Components/form/formContext'

export const FieldToggler = ({ children, show, hide, match }) => {

  const { getFieldValue } = React.useContext(FormContext)

  const value = getFieldValue(show);
  if (_.isString(show)) {
    show = value
  }

  if (_.isString(hide)) {
    show = !value
  }

  if(match && match !== value) {
    show = false;
  }

  return (show && <>{children}</>) || null
}

FieldToggler.defaultProps = {
  show: true
}
